export default __webpack_public_path__ + "static/media/logo-fjc.40928743.webp";